import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    tagRoot: {
      position: "relative",
      width: "100%",
    },
    tagContent: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      backgroundColor: "#000000",
      color: "#ffffff",
      padding: "4px 8px",
      fontSize: "12px",
      borderRadius: "4px 0px 3px",
    },
  },
  { name: "N0Tag" },
);

export { useStyles };
